/* eslint-disable no-unused-vars */
import React from 'react';
import { Page, Image, Text, View, StyleSheet } from '@react-pdf/renderer';
import logo from '../../../../assets/images/Logo.png';
import { roamingPdfStyles } from '../../../../helpers/pdfCommonStyles';
import { getTranslations } from '../translations';

const styles = StyleSheet.create({
  ...roamingPdfStyles,
  container: {
    ...roamingPdfStyles.container,
    height: 800,
  },

  section: {
    ...roamingPdfStyles.section,
    marginBottom: 5,
  },
});

const FivePage = () => {
  const { translations } = getTranslations( 'roaming_five_page');

  return (
    <Page style={styles.page}>
      <View style={styles.container}>
        <View style={styles.logo}>
          <Image src={logo} />
        </View>

        <View style={styles.titleContainer}>
          <Text style={styles.title}>{translations.title}</Text>
        </View>

        <View style={styles.content}>
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_1}</Text>
            <Text style={styles.sectionText}>{translations.section_text_1}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_2}</Text>
            <Text style={styles.sectionText}>{translations.section_text_2}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_3}</Text>
            <Text style={styles.sectionText}>{translations.section_text_3}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_4}</Text>
            <Text style={styles.sectionText}>{translations.section_text_4}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_5}</Text>
            <Text style={styles.sectionText}>{translations.section_text_5}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_6}</Text>
            <Text style={styles.sectionText}>{translations.section_text_6}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_7}</Text>
            <Text style={styles.sectionText}>{translations.section_text_7}</Text>
          </View>
          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_8}</Text>
            <Text style={styles.sectionText}>{translations.section_text_8}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_9}</Text>
            <Text style={styles.sectionText}>{translations.section_text_9}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_10}</Text>
            <Text style={styles.sectionText}>{translations.section_text_10}</Text>
          </View>

          <View style={styles.section}>
            <Text style={styles.sectionTitle}>{translations.section_head_11}</Text>
            <Text style={styles.sectionText}>{translations.section_text_11}</Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_12}</Text>
            <Text style={styles.sectionText}>{translations.section_text_12}</Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_13}</Text>
            <Text style={styles.sectionText}>{translations.section_text_13}</Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_14}</Text>
            <Text style={styles.sectionText}>{translations.section_text_14}</Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_15}</Text>
            <Text style={styles.sectionText}>{translations.section_text_15}</Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_16}</Text>
            <Text style={styles.sectionText}>{translations.section_text_16} </Text>
          </View>

          <View style={{ ...styles.section, marginLeft: 30 }}>
            <Text style={styles.sectionTitle}>{translations.section_head_17}</Text>
            <Text style={styles.sectionText}>{translations.section_text_17}</Text>
          </View>
        </View>
      </View>
      <View style={styles.footer}>
        <Text>{translations.link}</Text>
      </View>
    </Page>
  );
};

export default FivePage;
